<template>
  <DetailCard :dt="null">
    <template #heading>
      <span class="pi pi-building-columns"></span>
      <a :href="getEhrConstructionExternalUrl" target="_blank">
        {{ $t(`messages.detail.ehrConstruction.title`) }}
      </a>
    </template>
    <div v-for="field in fields" :key="field" class="grid grid-cols-2 gap-4 mb-4">
      <label :for="field" class="font-bold">
        {{ $t(`messages.detail.ehrConstruction.${field}`) }}
      </label>
      <InputText :id="field" v-model="ehrConstruction[field]" fluid @update:model-value="evaluationStore.save({ construction: { [field]: $event } })" />
    </div>

    <div v-for="field in fieldsWithTemplateValues" :key="field" class="grid grid-cols-2 gap-4 mb-4">
      <label :for="field" class="font-bold">
        {{ $t(`messages.detail.ehrConstruction.${field}`) }}
      </label>
      <PredefinedValuesInputComponent
        category="ehrConstruction"
        :name="field"
        :append-on-select="true"
        v-model="ehrConstruction[field]"
        @update:model-value="evaluationStore.save({ construction: { [field]: $event } })"
      />
    </div>
    <div v-for="field in ratingFields" :key="field" class="grid grid-cols-2 gap-4 mb-4">
      <label :for="field" class="font-bold">
        {{ $t(`messages.detail.ehrConstruction.${field}`) }}
      </label>
      <RatingMultiSelect
        v-model="ehrConstruction[field]"
        :field="field"
        :options="[1, 2, 3, 4, 5]"
        :maxSelectedLabels="2"
        :selectionLimit="2"
        placeholder="Vali kuni 2 hinnangut"
        size="base"
        tooltipPosition="right"
        @update:model-value="evaluationStore.save({ construction: { [field]: $event } })"
      />
    </div>
  </DetailCard>
</template>
<script setup>
import { storeToRefs } from 'pinia'
import { computed, readonly } from 'vue'
import PredefinedValuesInputComponent from '@/components/PredefinedValuesInputComponent.vue'
import RatingMultiSelect from '@/components/RatingMultiSelect.vue'
import { useDetailStore } from '@/stores/useDetailStore'
import { useEvaluationStore } from '@/stores/useEvaluationStore'
import DetailCard from '../DetailCard.vue'
import { useI18n } from 'vue-i18n'

const store = useDetailStore()
const evaluationStore = useEvaluationStore()
const { ehrConstruction, ehrId } = storeToRefs(store)
const { t } = useI18n()

const fields = readonly([
  'vundamendi_liik',
  'konstruktsioonide_materjal',
  'valisseina_valisviimistlus',
  'valisseina_liik',
  'katuste_katuselagede_materjal',
  'vahelagede_materjal',
  'katusekate',
])
const fieldsWithTemplateValues = readonly([
  'valisuksed',
  'siseuksed',
  'aknad',
  // 'rodu',
  'siseseinad',
  'vastavus_ehr',
  // 'hoone_seisuskord',
  'hoone_markused',
])

const ratingFields = readonly([
  'ehitise_seisukord',
])

const getEhrConstructionExternalUrl = computed(() => {
  return 'https://ehr.ee/app/link/b/' + ehrId.value + '/materials'
})
</script>
